import axios from 'axios';
import {
  FingerPrint,
  HeroAjaxCreatePaxRequest,
  HeroApiBooking, HeroApiBookingValidateResult,
  HeroApiCreateBookingRequest,
  HeroApiCreatePaxResult,
  HeroApiValidateWindcaveSessionResponse,
  HeroApiWindcaveSessionRequest,
  HeroApiWindcaveSessionResponse,
  Pax,
  ProductPricingMulti
} from './models';

const STAGING_URL = __API_URL__;
const AK = __API_KEY__;
const HEADERS = {
  'apiKey': AK,
  'Content-Type': 'application/json'
};

export function initWindcaveSession(data: HeroApiWindcaveSessionRequest) {
  return axios.post<HeroApiWindcaveSessionResponse>(
    `${STAGING_URL}/init-taronga-payment`,
    data,
    { headers: HEADERS }
  );
}

export function validateWindcaveSession(sessionId: string, supplierUrl: string) {
  return axios.get<HeroApiValidateWindcaveSessionResponse>(
    `${STAGING_URL}/windcave/${supplierUrl}?sessionId=${sessionId}`,
    { headers: HEADERS }
  );
}

export function getProductPricingMulti(branchId: number | string, siteId: number, start: string, end: string, paxs: Pax[], promoCode: string, discount: string, fromOnly: boolean) {
  return axios.post<ProductPricingMulti>(
    `${STAGING_URL}/productpricingmulti/${start}/${end}?bId=${branchId}&siteId=${siteId}&promoCode=${promoCode}&discountCode=${discount}` + (fromOnly ? '&fromOnly=true' : ''),
    { ageRoomList: paxs },
    { headers: HEADERS }
  );
}

export function createPax(data: HeroAjaxCreatePaxRequest) {
  return axios.post<HeroApiCreatePaxResult>(
    `${STAGING_URL}/pax`,
    data,
    { headers: HEADERS }
  );
}

export function createBooking(data: HeroApiCreateBookingRequest) {
  return axios.post<HeroApiBooking>(
    `${STAGING_URL}/bookings`,
    data,
    { headers: HEADERS }
  );
}

export function createPayment(data: HeroApiCreateBookingRequest) {
  return axios.post<HeroApiBooking>(
    `${STAGING_URL}/bookings`,
    data,
    { headers: HEADERS }
  );
}

export function validateBooking(data: HeroApiBooking) {
  return axios.post<HeroApiBookingValidateResult>(
    `${STAGING_URL}/bookingvalidate/${data.id}`,
    data,
    { headers: HEADERS }
  );
}

export function getFingerPrint(data: HeroApiBooking) {
  return axios.get<FingerPrint>(
    `${STAGING_URL}/fingerprint/${data.id}`,
    { headers: HEADERS }
  );
}
